<template>
	<div class="pages">
		<sub-ibox-title><p slot="title">微信菜单管理</p></sub-ibox-title>
		<section class="content">
			<div class="fx">
				<div class="menu fx-shrink">
					<h3>{{publicInfo.nick_name || '公众号名称'}}</h3>
					<div class="menu-btn-cont">
						<ul class="fx menu-btn fx-align" v-if="menu">
							<li class="fx-fill fx-align " v-for="(item,index) in menu.button || []">
								<dl v-show="active==index">
									<dd v-for="(subItem, subIndex) in item.sub_button" :class="{'active':subActive==subIndex}" @click="handleSelectedMenu(index,subIndex)">{{subItem.name}}</dd>
									<dd class="sub-add" v-if="item.sub_button.length <5" @click="handleAddMenu(item.sub_button)"><span class="icon-add"></span></dd>
								</dl>
								<div class="fx-fill fx-align btns" :class="[active==index && subActive == null ? 'active': '']"  @click="handleSelectedMenu(index)">
									{{item.name}}
								</div>
							</li>
							<li class="fx-fill fx-align" v-show="menu.button.length <3" @click="handleAddMenu(menu.button)">
								<div class="fx-fill fx-align btns icon-add">
								</div>
							</li>
						</ul>
					</div>
				</div>
				<div class="menu-edit fx-fill b-r-5" v-if="editBtn.sub_button">
					<div class="p-b-20">
						<p align="right">
							<a class="del-menu" @click="handleDelMenu">删除当前菜单</a>
						</p>
					</div>
					<div class="fx fx-y-center">
						<p>菜单名称：</p>
						<p class="fx-fill"><input class="input" type="text" placeholder="字数不超过6个汉字" maxlength="6" v-model="editBtn.name" /></p>
					</div>
					<div v-show="editBtn.sub_button.length <=0">
						<div class="fx p-t-20 p-b-20" >
							<p>菜单内容：</p>
							<div class="fx radio-cont">
								<!--<p class="fx fx-y-center"><input class="radio" type="radio" id="text" name="chack" value="text" v-model="editBtn.type" /><label for="text" class="m-l-5">发送文字</label></p>-->
								<p class="fx fx-y-center">
									<input class="radio" type="radio" id="news" name="chack" value="media_id" v-model="editBtn.type" />
									<label for="news" class="m-l-5">发送素材</label>
								</p>
								<p class="fx fx-y-center"><input class="radio" type="radio" id="link" name="chack" value="view" v-model="editBtn.type" /><label for="link" class="m-l-5">跳转连接</label></p>
								<p class="fx fx-y-center"><input class="radio" type="radio" id="click" name="chack" value="click" v-model="editBtn.type" /><label for="click" class="m-l-5">发送关键词</label></p>
								<p class="fx fx-y-center"><input class="radio" type="radio" id="miniprogram" name="chack" value="miniprogram" v-model="editBtn.type" /><label for="miniprogram" class="m-l-5">小程序</label></p>
							</div>
						</div>
						<!--<div v-show="editBtn.type =='text'">
							<div class="fx fx-y-center">
								<p class="p-r-10">文字内容:</p>
								<p class="fx-fill">
									<input class="input" type="text" v-model="editBtn.value" placeholder="文字内容" />
								</p>
							</div>
						</div>-->
						<div v-show="editBtn.type =='media_id'">
							<div class="fx fx-y-center">
								<p class="p-r-10">素材名称:</p>
								<p class="fx-fill" v-show="mediaName"><input class="input" type="text" disabled="disabled" v-model="mediaName" placeholder="请选择素材" /></p>
								<p class="fx-fill" v-show="!mediaName"><input class="input" type="text" disabled="disabled" v-model="editBtn.media_id" placeholder="media_id" /></p>
								<p class="p-10">
									<a class="z-btn z-btn-primary b-r-3" @click="handleShowLayer">{{editBtn.media_id ? '重选素材':'选择素材'}}</a>
								</p>
							</div>
						</div>
						<div v-show="editBtn.type =='view'">
							<div class="fx fx-y-center">
								<p class="p-r-10">跳转连接:</p>
								<p class="fx-fill">
									<input class="input" type="text" v-model="editBtn.url" placeholder="跳转连接" />
								</p>
							</div>
						</div>
						<div v-show="editBtn.type =='click'">
							<div class="fx fx-y-center">
								<p class="p-r-10">关键词:</p>
								<p class="fx-fill">
									<input class="input" type="text" v-model="editBtn.key" placeholder="请输入关键词" />
								</p>
							</div>
							<p class="p-t-10 tips">tips:这里需要配合关键词推送消息一起使用</p>
						</div>
						<div v-show="editBtn.type =='miniprogram'">
							<div class="fx fx-y-center">
								<p class="p-r-10">小程序的appid:</p>
								<p class="fx-fill">
									<input class="input" type="text" v-model="editBtn.appid" placeholder="请输入小程序的appid" />
								</p>
							</div>
							<div class="fx fx-y-center p-t-10">
								<p class="p-r-10">小程序的页面路径:</p>
								<p class="fx-fill">
									<input class="input" type="text" v-model="editBtn.pagepath" placeholder="请输入小程序的页面路径，如：pages/index" />
								</p>
							</div>
							<p class="p-t-10 tips">tips:需要和公众号进行关联才可以把小程序绑定带微信菜单上哟！</p>
						</div>
					</div>
				</div>
				<div class="menu-edit" v-show="!editBtn.sub_button">
					请选择菜单
				</div>
			</div>

			<div class="m-t-20 submit-btn">
				<a class="z-btn z-btn-primary b-r-3" @click="handleSubmit">保存并发布菜单</a>
			</div>
		</section>
		<z-layers-material 
			:is-show="isLayerBox" 
			:title="'素材管理'" 
			@handleOk="handleConfirm" 
			@handleCancel="handleCancel">
			<z-material 
				:is-get-material="isLayerBox" 
				:is-tab-bar=true 
				:type="'news'" 
				@handleSelectMaterial="handleSelectMaterial
	  			">
			</z-material>
		</z-layers-material>
	</div>
</template>
<script>
	import { mapActions, mapState } from 'vuex'
	
	export default {
		name: 'wxMenu',
		components: {
		},
		data() {
			return {
				params: {
					menu: null
				},
				isLayerBox: false,
				mediaId : null,
				mediaName : null,
				active: null,
				subActive: null,
				menuType: 'view',
				editBtn: {},
				btn: {
					"type": "view",
					"name": "菜单",
					"url": "http://www.xinyebang.com/",
					"sub_button": []
				}
			}
		},
		mounted() {
			this.handleGetWxMenu()
		},
		/*
		 * 属性计算
		 */
		computed: {
			btnType: {
				get() {
					return this.menuType
				},
				set(value) {
					let type = ''
					switch(value) {
						case 'img': //素材:图片、图文、视频、语音
							type = 'media_id'
							break;
						case 'voice': //素材，图片、图文、视频、语音
							type = 'media_id'
							break;
						case 'video': //素材，图片、图文、视频、语音
							type = 'media_id'
							break;
						case 'view_limited': //选择图文 可直接打开图文页面
							type = 'view_limited'
							break;
						default:
							type = value
							break;
					}
					this.menuType = value
					this.editBtn.type = type
				}

			},
			...mapState({
				menu: state => state.menu.menu.menu,
				publicInfo: state => state.auth.publicInfo || {}
			})
		},
		/*
		 * 事件处理
		 */
		methods: {
			handleCancel() {
				this.isLayerBox = false
			},
			handleConfirm() {
				this.isLayerBox = false
				this.editBtn.media_id = this.mediaId 
				this.mediaName = this.name
			},
			handleShowLayer() {
				this.isLayerBox = true
			},
			handleSelectMaterial(item) {
				this.$log(JSON.stringify(item))
				this.mediaId = item ? item.media_id: null
				this.name = item.name ? item.name : item.content.news_item[0].title
			},
			handleSelectedMenu(index = null, subIndex = null) { //选中菜单
				this.active = index
				this.subActive = subIndex
				this.editBtn = parseInt(subIndex) >= 0 ? this.menu.button[index].sub_button[subIndex] : this.menu.button[index]
			},
			handleAddMenu(button) { //添加菜单
				let btn = {
					"type": "view",
					"name": "菜单",
					"url": "http://www.xinyebang.com/",
					"sub_button": []
				}
				button.push(btn)
			},
			handleDelMenu() { //删除菜单
				this.$confirm(`确定要删除此菜单?`).then(action => {
					if(parseInt(this.subActive) >= 0) {
						(this.menu.button[this.active].sub_button).splice(this.subActive, 1)
						if(this.menu.button[this.active].sub_button.length == 0) {
							let btn = {
								"type": "view",
								"name": this.menu.button[this.active].name,
								"url": "http://www.xinyebang.com/",
								"sub_button": []
							}
							this.menu.button[this.active] = btn
						}
						this.editBtn = this.menu.button[this.active]
					} else {
						(this.menu.button).splice(this.active, 1)
						this.active = null
						this.editBtn = {}
					}
					this.subActive = null
				},()=>{});
			},
			async handleSubmit() { //提交微信菜单
				this.params.menu = this.menu
				try{
					await this.modifyWxMenu(this.params)
					this.$success('保存成功')
				}catch(e){
					this.$errorMsg('保存失败,请检测菜单内容是否填写')
				}
			},
			async handleGetWxMenu() { //获取微信菜单
				try{
					await this.getWxMenu()
				}catch(e){
					this.$errorMsg('获取菜单失败')
				}
			},
			...mapActions(['getWxMenu', 'modifyWxMenu']),
		}
	}
</script>
<style scoped lang="scss">
	@import "src/assets/css/common.scss";
	.content{
		min-width: 800px;
		border-top: none;
	}
	.menu {
		width: 350px;
		height: 716px;
		background: url(../../../assets/img/iphone.png) no-repeat;
		background-size: 100% auto;
		padding-top: 583px;
		position: relative;
		h3{
			width: 304px;
			position: absolute;
			top: 91px;
			left: 50%;
			background: #363535;
			color: #fff;
			text-align: center;
			padding: 15px 0;
			margin-left: -152px;
			font-size: 16px;
		}
		ul {
			width: 302px;
			height: 45px;
			background: $color-f2f2f2;
			margin: 0 auto;
			li {
				position: relative;
				width: 100%;
				height: 100%;
				font-size: 12px;
				.btns {
					border: solid 1px $color-border;
					height: 100%;
					cursor: pointer;
				}
				.active {
					border: solid 1px $color-btn;
					color: $color-btn;
				}
				.icon-add {
					color: $color-btn;
				}
			}
		}
		dl {
			position: absolute;
			width: 100%;
			left: 0;
			bottom: 50px;
			dd {
				position: relative;
				padding: px-em(20px);
				border: solid 1px $color-border;
				text-align: center;
				background: $color-white;
				cursor: pointer;
				span {
					font-size: 12px;
					color: $color-btn;
				}
				&:last-child:after,
				&:last-child:before {
					top: 100%;
					left: 50%;
					border: solid transparent;
					content: " ";
					height: 0;
					width: 0;
					position: absolute;
					pointer-events: none;
				}
				&:last-child:after {
					border-color: rgba(249, 249, 249, 0);
					border-top-color: $color-border;
					border-width: 6px;
					margin-left: -6px;
				}
				&:last-child:before {
					border-color: rgba(204, 204, 204, 0);
					border-top-color: $color-border;
					border-width: 7px;
					margin-left: -7px;
				}
			}
		}
	}
	
	.menu-edit {
		position: relative;
		margin-left: px-em(40px);
		min-width: px-em(800px);
		background: $color-lightgray;
		border: solid 1px $color-border;
		padding: px-em(40px);
		&:after, &:before {
			right: 100%;
			top: 85%;
			border: solid transparent;
			content: " ";
			height: 0;
			width: 0;
			position: absolute;
			pointer-events: none;
		}
		
		&:after {
			border-color: rgba(238, 238, 238, 0);
			border-right-color: $color-border;
			border-width: 20px;
			margin-top: -20px;
		}
		&:before {
			border-color: rgba(204, 204, 204, 0);
			border-right-color: $color-border;
			border-width: 21px;
			margin-top: -21px;
		}
		
		.radio-cont {
			p {
				padding: 0 5px;
				label {
					cursor: pointer;
				}
				input{
					transition: all 0.2s ease;
					&:active{
						opacity: 0.1;
					}
				}
			}
		}
		.del-menu {
			border-radius: 2px;
			padding: px-em(20px);
			color: $color-btn;
			&:hover{
				color: darken($color-btn,10%);
				background: rgba(0,0,0,0.1);
			}
		}
		.tips{
			color: $color-skyblue;
		}
	}
	.submit-btn{
		padding-left: 90px;
	}
	@media only screen and (min-width:0px) and (max-width:640px) {
		.sub-ibox-title,.content {
			min-width: px-em(1600px);
		}
	}
</style>


// WEBPACK FOOTER //
// WxMenu.vue?3e97b19c